export default function () {
  const widgetName = 'customMapContent';
  const widgetOpts = customMapContentOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [],
    buyNowButton: false,
    moreButton: {
      visible: false,
      text: 'Get Directions',
    },
    showDescription: true,
    textOverImage: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      const widgetCount = widgetData.length;

      if (widgetCount <= 0) {
        $(`#${widgetName} , #map-feature`).remove();
      } else {
        createCustomMap(widgetData);
      }
    },
  });

  function createCustomMap(data) {
    $(`#${widgetName}`).remove();
    let $map = $('#map-feature .map-inner');

    const newStructure = `
      <div class="map-box-container">
        <div class="map-image-desktop" style="background-image: url(${data[0].ImageWithPath})"></div>
          <div class="map-box-content">
            <img src='${CLIENTRESOURCEPATH}dist/images/footer-main-logo.svg' alt="Enumclaw Expo Center & King County Fair"
              class="map-logo">
            <div class="left-content">
              <div class="map-box-description">
                ${data[0].Description}
              </div>
              <a href='${data[0].URL}}' class="button">${data[0].Title}</a>
            </div>
          </div>
      </div>
      `;

    $map.append(newStructure);
  }
}
